import userIcon from "./user.svg";
import cartIcon from "./cart.svg";
import arrowLeftIcon from "./arrowLeft.svg";
import supportIcon from "./support.svg";
import trackIcon from "./track.svg";
import guaranteeIcon from "./guarantee.svg";
import mobileIcon from "./mibile.svg";
import whatsappIcon from "./whatsapp.svg";
import telegramIcon from "./telegram.png";
import instagramIcon from "./instagram.png";
import facebookIcon from "./facebook.png";
import orangeArrowLeftIcon from "./orangeArrowLeftIcon.svg";
import closeIcon from "./close.svg";
import editIcon from "./edit.svg";
import smallArrowLeftIcon from "./smallArrowLeft.svg";
import downloadIcon from "./download.svg";
import trashIcon from "./trash.svg";
import microscope from "./microscope.svg";
import twoArrow from "./twoArrow.svg";
import LoginImg from "./login.png";
import MarvelStamp from "./MarvelStamp.png";
import userName from "./username.svg";
import newPhone from "./newPhone.svg";
import oldPhone from "./oldPhone.svg";
import codeMeli from "./codeMeli.svg";
import postCode from "./postCode.svg";
import creditCard from "./creditCard.svg";
import email from "./email.svg";
import userGroup from "./user-group.svg";
import rejection from "./rejections.svg";
import calander from "./calander.svg";
import ostan from "./ostan.svg";
import city from "./newcity.svg";
import yourImage from "./yourImage.svg";
import choseImage from "./choseImage.svg";
import image from "./image.svg";
import newAddress from "./newAddress.svg";
import order from "./order.svg";
import date from "./date.svg";
import resid from "./resid.svg";
import caltuher from "./culther.svg";
import clock from "./clock.svg";
import printer from "./printer.svg";
import FactorFooter from "./FactorFooter.png";
import gender from "./gender.jpg";

export {
  userIcon,
  cartIcon,
  arrowLeftIcon,
  orangeArrowLeftIcon,
  trackIcon,
  supportIcon,
  guaranteeIcon,
  mobileIcon,
  whatsappIcon,
  telegramIcon,
  instagramIcon,
  facebookIcon,
  closeIcon,
  editIcon,
  smallArrowLeftIcon,
  downloadIcon,
  trashIcon,
  microscope,
  twoArrow,
  LoginImg,
  MarvelStamp,
  FactorFooter,
  userName,
  newPhone,
  oldPhone,
  codeMeli,
  postCode,
  creditCard,
  email,
  userGroup,
  rejection,
  calander,
  ostan,
  city,
  yourImage,
  choseImage,
  image,
  newAddress,
  order,
  date,
  resid,
  caltuher,
  clock,
  printer,
  gender,
};
